import {observable, action, computed, set } from "mobx";
import AppConstant from "../appConstants";
import { cloneDeep } from "lodash/lang";
import { getFilteredData } from "../components/common/filterUtilities";
class IBPlanningStore{
    //original data Sources
    @observable routesList=[];
    @observable stopsList=[];
    @observable shipmentsList=[];
    @observable newShipments = {};
    @observable quickFilter=AppConstant.EMPTY_STRING;
    @observable kpiData=[];
    @observable planDate= null;
    @observable disableStoreUpdate=false;
    @observable isLassoRouteCreated=false;
    @observable newRoutesTobeCleared=null;
    @observable isDataRefreshInProgress=false;
    @observable isPublishInProgress=false;

    // derived data sources
    @observable routeWithStops=[];
    @observable filteredRouteStops=[];
    @observable selectedRouteNameList=[];
    @observable selectedShipmentIDList=[];

    @observable plannedShipmentsList=[];
    @observable filteredRouteShipments=[];
    @observable filteredShipments=[];
    @observable routeMapColorList=[];
    @observable filteredShipmentsOnMap=[];
    @observable staticClientData = null;
    @observable routeTypeList = [{label: "City", value: 'City'}, {label:"Trap", value: 'Trap'}];
   
    constructor(){
        const newShipments = sessionStorage.getItem("newShipments") ? JSON.parse(sessionStorage.getItem("newShipments")) : {};
        set(this.newShipments, newShipments);
    }

    @action updateDataRefreshProgress(value){
        this.isDataRefreshInProgress=value; 
    }

    // Updating orignal dataSource
    @action addRoutes(routesList, routeMapColorList){
        this.routesList.replace(this.assignColorToRoute(routesList, routeMapColorList));
    }

    @action addStops(stopsList){
        this.stopsList.replace(stopsList);
    }

    @action addShipments(shipmentList){
        this.shipmentsList.replace(shipmentList.sort((shipment1, shipment2) => (shipment1?.routeName ?? '') > (shipment2?.routeName ?? '') ? -1 : 1));
        this.filterPlannedShipments();
        this.filterShipments();
        this.filterRouteShipments();
        this.updateFilteredShipments(shipmentList);
    }

    @action updateKPIData(kpiData){
        this.kpiData.replace(kpiData);
    }

    @action updateNewRoutesToBeCleared(routeName=null){
        this.newRoutesTobeCleared = routeName;
    }

    @action updateNewShipments(newShipments){
        if(!newShipments && !newShipments.data){
            sessionStorage.removeItem("newShipments");
        }
        if(newShipments && newShipments.data && !newShipments.data.length){
            this.updateNewRoutesToBeCleared();
        }
        sessionStorage.setItem("newShipments", JSON.stringify(newShipments));
        set(this.newShipments, newShipments);
    }

    @action refreshDataSources(updatedData){
        const {routesData, stopsData, newShipments, iconsColor, planDate, getNewBills} = updatedData;
        this.addRoutes(routesData, iconsColor);
        this.addStops(stopsData);
        this.updatePlanDate(planDate);
        if(getNewBills){
            const newBillsData = {
                scenarioID:newShipments.scenarioID,
                data:this.newShipments.data ? this.newShipments.data.concat(newShipments.data) : newShipments.data
            }
            this.updateNewShipments(newBillsData);
        }
    }

    @action updatePlanDate(planDate){
        this.planDate = planDate;
    }

    @action setdisableStoreUpdate(value){
        this.disableStoreUpdate=value;
    }

    // updating derived data sources
    // ROUTES changes
    @action filterRouteStops(){
       const filteredRouteStopList =  this.selectedRouteNameList.length > 0 ?
                                      this.stopsList.filter(stop=>this.selectedRouteNameList.includes(stop.routeName)) : this.stopsList;
        this.filteredRouteStops.replace(cloneDeep(filteredRouteStopList));
    }

    @action setReseqeuncedRouteStops(resequencedStops){
       // This will used in RoutesMap and Stops grid, the data can be changed without affecting the main data source(Eg: Stop sequence update)
       // so that it can be easily discarded if changes are to be rejected
        this.filteredRouteStops.replace(cloneDeep(resequencedStops));
        this.updateRouteWithStopsAndShipments();
    }

    @action refreshFilterStops(){
        this.updateSelectedRoutes(this.selectedRouteNameList);
    }

    @action updateSelectedRoutes(routeNameList){
            this.selectedRouteNameList.replace(routeNameList);
            this.filterRouteShipments();
            this.filterRouteStops();
            this.updateRouteWithStopsAndShipments();
    }

    @action updateSelectedShipments(shipmentsList){
        this.selectedShipmentIDList.replace(shipmentsList);
    }

    updateRouteWithStopsAndShipments(){
        let selectedRoutes = this.routesList.filter(route => this.selectedRouteNameList.includes(route.routeName));
        const routeWithStops =  selectedRoutes.map(route=>{
            if(!route.routeStops){
                route.routeStops =[];
            }
            if(!route.routeShipments){
                route.routeShipments =[];
            }
            route.routeStops.replace(this.filteredRouteStops.filter(stop => stop.routeName === route.routeName ));
            if(route.isTrapRoute || !route.routeId){ // routeShipments are only used to be displayed Routes map when route is a trap route
                route.routeShipments.replace(this.filteredRouteShipments.filter(shipment => shipment.routeName === route.routeName ));
            }
            return route;
        });
        this.routeWithStops.replace(routeWithStops)
    }

    assignColorToRoute(routesList, routeMapColorList) {
        const colorCount = routeMapColorList.length
        return routesList.map((route, index)=>{
            route.color = routeMapColorList[index % colorCount ];
            route.routeKey = route.routeName;
            return route;
        });
    }

    @computed get routesPanelLabel(){
        return `${this.routesList.length} Routes`;
    }

    @computed get routeNameList(){
        return this.routesList.map(route => ({label: route.routeName, value: route.routeId}));
    }

    @computed get deliveryRouteNameList(){
        return this.routesList.filter(route => !route.isTrapRoute).map(route => ({label: route.routeName, value: route.routeId}));
    }

    // SHIPMENTS

    @action filterPlannedShipments(){
        this.plannedShipmentsList.replace(this.shipmentsList.filter(shipment => shipment.routeName));
    }

    @action filterRouteShipments(){
        if(this.selectedRouteNameList.length > 0){
            const filteredShipments = this.plannedShipmentsList.filter(shipment=>this.selectedRouteNameList.includes(shipment.routeName));
            this.filteredRouteShipments.replace(cloneDeep(filteredShipments));
        }
        else{
            this.filteredRouteShipments.replace(cloneDeep(this.plannedShipmentsList));
        }
    }

    @action filterShipments(){
        if(this.quickFilter){
            this.filteredShipments.replace(getFilteredData(this.shipmentsList, this.quickFilter, this.planDate));
        } else {
            this.filteredShipments.replace(this.shipmentsList);
        }

    }

    @action updateFilteredShipments(filteredData){
        if(filteredData){
            this.filteredShipmentsOnMap.replace(filteredData);
        }else{
            this.filteredShipmentsOnMap.replace(this.shipmentsList);
        }
    }

    @action updateQuickFilter(updatedQuickFilterString){
        // clear shipments only when quick filter has changed
        if(this.quickFilter !== updatedQuickFilterString){
            this.updateSelectedShipments([]);
        }
        this.quickFilter = updatedQuickFilterString;
        this.filterShipments();
    }

    @action setIsLassoRouteCreated(isLassoRouteCreated){
        this.isLassoRouteCreated = isLassoRouteCreated;
    }

    @action setIsPublishInProgress(isInProgress){
        this.isPublishInProgress = isInProgress;
    }

    @action getRouteStops(routeId){
        return this.stopsList.filter(
          (stop) => stop.routeId?.toLowerCase() === routeId?.toLowerCase()
        );
    }

    @action getRoute(routeId){
        return this.routesList.find(
          (route) => route.routeId?.toLowerCase() === routeId?.toLowerCase()
        ) ?? null;
    }
    @action setStaticClientData(clientData) {
        this.staticClientData = clientData;
      }
      
      @action getStaticClientData() {
        return this.staticClientData;    
      }
  
      @computed get serviceLevelList() {
          return this.staticClientData?.serviceLevelList || [];
      }
}
export default new IBPlanningStore;